import { useContext } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';
import { MapItemList } from '@atom/map';

import InventoryPortalContext from '../InventoryPortalContext';

import classes from './inventoryAssetSidebar.module.css';

const InventoryStackListSidebar = () => {
  const { stackAssets } = useContext(InventoryPortalContext);
  const [, { updateSearchParams }] = useNavigation();

  const identifyIds = stackAssets.map(asset => asset.id);

  return (
    <div className={classes.container}>
      <MapItemList
        data={{ assets: stackAssets }}
        identifyIds={identifyIds}
        onSelectAsset={assetId =>
          updateSearchParams({ id: assetId, stack: null })
        }
        onCloseIdentify={() => updateSearchParams({ stack: null })}
      />
    </div>
  );
};

export default InventoryStackListSidebar;
